import { createSlice } from '@reduxjs/toolkit';
import { createDocuSignEnvelope } from 'thunks';

interface DocuSignEnvelopeState {
  isLoading: boolean;
}

const initialState: DocuSignEnvelopeState = {
  isLoading: false,
};

const docuSignEnvelope = createSlice({
  name: 'docuSignEnvelope',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createDocuSignEnvelope.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createDocuSignEnvelope.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createDocuSignEnvelope.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default docuSignEnvelope.reducer;
